import React from "react";
import { pdf } from "@react-pdf/renderer";
import PDFDocument from "../components/pdf/PDFDocument";

/**
 * Renders biodata PDF and reduces typography until it fits on a single A4 page.
 * Tries largest readable font first, then slightly smaller, down to a floor.
 */
export async function renderBiodataPdfSinglePage(props, pdfjsGetDocument) {
  const fontSizes = [15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4];
  let lastBlob = null;
  for (const contentFontSize of fontSizes) {
    const blob = await pdf(
      <PDFDocument {...props} contentFontSize={contentFontSize} />
    ).toBlob();
    lastBlob = blob;
    const data = await blob.arrayBuffer();
    const doc = await pdfjsGetDocument({ data }).promise;
    if (doc.numPages <= 1) {
      return { blob, contentFontSize };
    }
  }
  return { blob: lastBlob, contentFontSize: 4 };
}
